module.exports = "<div><div class=head><l10n>Justification</l10n>&nbsp; <span class=sup><l10n>Justification is required before this trip can be booked</l10n></span></div><section class=\"container-panel box\"><div class=item-form><label class=justification-label><l10n>Justification for out of policy booking</l10n></label> <textarea name=JustificationText ng-model=$ctrl.tripDetails.JustificationText maxlength=500 class=\"form-control elem-note\" required/></div></section></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/trip/trip-justification/trip-justification.html
// module id = 3523
// module chunks = 0